/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  DashboardChartType,
  GrossAndNetProfitDto,
  GrossAndNetProfitPoint,
  GrossAndNetProfitValue,
} from '../dto';

export const GrossAndNetProfitMapper = entity<GrossAndNetProfitDto>({
  values: arrayOf(subentity<GrossAndNetProfitValue>({
    points: arrayOf(subentity<GrossAndNetProfitPoint>({
      type: enumeration(DashboardChartType),
    })),
  })),
});
